import { CurrencyPipe } from '@angular/common';
import { Component, computed, input, model, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { IProductoCarritoData } from '@core/interfaces/entidades/productoCarrito.entidad';
import { UiDialog } from '@shared/components/ui';
import { AgregarProductoVenta } from '../agregar-producto-venta/agregar-producto-venta';
import { ModalConfirmacion } from '../modal-confirmacion/modal-confirmacion';

@Component({
  selector: 'app-agregar-producto-2',
  imports: [CurrencyPipe, UiDialog, AgregarProductoVenta, ModalConfirmacion],
  templateUrl: './agregar-producto-2.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agregar-producto-2.css',
})
export class AgregarProducto2 {
  // datos
  sync_manual = input<boolean>(false);
  productos_carrito = model<IProductoCarritoData[]>([]);
  modal_agregar_producto = signal(false);
  modal_confirmacion_eliminar_todos_productos = signal(false);

  calcularTotal = computed(() => {
    return this.productos_carrito().reduce((total, producto) => {
      return total + producto.precio * producto.cantidad;
    }, 0);
  });

  agregar_productos = output<IProductoCarritoData[]>();
  eliminar_producto = output<number>();

  // metodos
  onAgregarProducto(productos: IProductoCarritoData[]) {
    const productos_actuales = this.productos_carrito();
    if (this.sync_manual() === false) {
      this.productos_carrito.set([...productos_actuales, ...productos]);
    }
    this.modal_agregar_producto.set(false);
    this.agregar_productos.emit(productos);
  }

  eliminarProducto(index: number) {
    const productos_actuales = this.productos_carrito();
    if (this.sync_manual() === false) {
      productos_actuales.splice(index, 1);
      this.productos_carrito.set([...productos_actuales]);
    }
    this.eliminar_producto.emit(index);
  }

  eliminarTodosProductos() {
    if (this.sync_manual() === false) {
      this.productos_carrito.set([]);
    }
    this.eliminar_producto.emit(-1); // Emitir -1 para indicar que se eliminaron todos los productos
    this.modal_agregar_producto.set(false);
    this.modal_confirmacion_eliminar_todos_productos.set(false);
  }
}
